export enum EventFrequency {
  NoRepeat = "no-repeat",
  EveryDay = "every-day",
  EveryWeek = "every-week",
}
